import { useEffect, useState } from 'react'

import { useUpdateGasEstimation } from '~/hooks/useTransactions'
import { BackendTransaction, BasicTransactionType } from '~/types'

export function useCheckIfQuoteExpired(transaction?: BackendTransaction) {
  const updateGasEstimation = useUpdateGasEstimation()
  const [isLoading, setIsLoading] = useState(false)
  const [hasError, setHasError] = useState(false)

  const types = transaction?.types as BasicTransactionType[]
  const isSwap = types?.includes(BasicTransactionType.Swap)

  useEffect(() => {
    if (!transaction?.id || !isSwap) return

    let isCancelled = false
    setHasError(false)
    setIsLoading(true)

    void updateGasEstimation({ transactionId: transaction.id })
      .then((result) => !isCancelled && !result && setHasError(true))
      .finally(() => !isCancelled && setIsLoading(false))

    return () => {
      isCancelled = true
    }
  }, [transaction?.id, isSwap, updateGasEstimation])

  return { hasError, isLoading }
}
